import { combineReducers } from 'redux';

import * as actionTypes from '@store/dashboard/commercial-dashboard/action-types';

const getSelectedBrand = (state = '', { type, payload }) => {
	switch (type) {
		case actionTypes.SET_SELECTED_BRANDS_FAILURE:
			return state;
		case actionTypes.SET_SELECTED_BRANDS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getSelectedManager = (state = '', { type, payload }) => {
	switch (type) {
		case actionTypes.SET_SELECTED_MANAGER_FAILURE:
			return state;
		case actionTypes.SET_SELECTED_MANAGER_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getOrderSearchValue = (state = '', { type, payload }) => {
	switch (type) {
		case actionTypes.SET_ORDER_SEARCH_INPUT_FAILURE:
			return state;
		case actionTypes.SET_ORDER_SEARCH_INPUT_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const commercialDashboardReducer = combineReducers({
	selectedBrand: getSelectedBrand,
	selectedManager: getSelectedManager,
	orderSearchValue: getOrderSearchValue
});

export default commercialDashboardReducer;
